import React, { useState, useContext } from "react";
import ServiceList from "./ServiceList";
import CreateServiceForm from "./CreateServiceForm";
import EditServiceForm from "./EditServiceForm";
import { AuthContext } from "../../contexts/AuthContext";

const Services = () => {
  const [activeTab, setActiveTab] = useState("list");
  const [editService, setEditService] = useState(null);
  const { user } = useContext(AuthContext);

  // Check if user has admin role
  const isAdmin = user?.role?.toLowerCase() === "admin";

  const handleEditClick = (service) => {
    setEditService(service);
    setActiveTab("edit");
  };

  const handleCancelEdit = () => {
    setEditService(null);
    setActiveTab("list");
  };

  const handleCreateSuccess = () => {
    setActiveTab("list");
  };

  const handleUpdateSuccess = () => {
    setEditService(null);
    setActiveTab("list");
  };

  // If not admin, show read-only view
  if (!isAdmin) {
    return (
      <div className="container mt-4">
        <div className="alert alert-info" role="alert">
          <h4 className="alert-heading">View Only Access</h4>
          <p>
            You can view services but cannot create or modify them. Contact an
            administrator if you need to make changes.
          </p>
        </div>
        <ServiceList onEdit={null} readOnly={true} />
      </div>
    );
  }

  return (
    <div className="container mt-4">
      {/* Header */}
      <div className="mb-4">
        <h1>Service Management</h1>
        <p className="text-muted">Manage services and rates for customers</p>
      </div>

      {/* Tabs Navigation */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("list");
              setEditService(null);
            }}
          >
            All Services
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "create" ? "active" : ""}`}
            onClick={() => setActiveTab("create")}
            disabled={editService !== null} // Disable when editing
          >
            Create Service
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="tab-content mt-3">
        {activeTab === "list" && <ServiceList onEdit={handleEditClick} />}

        {activeTab === "create" && (
          <CreateServiceForm onSuccess={handleCreateSuccess} />
        )}

        {activeTab === "edit" && editService && (
          <EditServiceForm
            service={editService}
            onCancel={handleCancelEdit}
            onUpdated={handleUpdateSuccess}
          />
        )}
      </div>
    </div>
  );
};

export default Services;
